// Simple mode in Design (M14): the template picker, or the ad (canvas) with its form. No tools, no docks:
// Make an ad → pick a template → it fills with the photo → type name and price → Save PNG.
import { useEffect } from 'react';
import { useT } from '../../../i18n';
import { useDesign } from '../../state';
import { DesignCanvas, fitToWindow } from '../DesignCanvas';
import { useDesignUi } from '../designUi';
import { useAdUi } from '../../ad/actions';
import { TemplatePicker } from './TemplatePicker';
import { AdForm } from './AdForm';
import s from './Ad.module.css';

export function AdStudio() {
  const t = useT();
  const doc = useDesign((d) => d.doc);
  const picker = useAdUi((a) => a.picker);
  const busy = useAdUi((a) => a.busy);
  const canUndo = useDesign((d) => d.history.past.length > 0);
  const canRedo = useDesign((d) => d.history.future.length > 0);
  // Simple mode only pans: a tap on the ad must not move things by accident.
  useEffect(() => useDesignUi.getState().set({ tool: 'hand', selection: [] }), []);
  const docId = doc?.id;
  useEffect(() => {
    if (docId) requestAnimationFrame(fitToWindow);
  }, [docId]);
  if (picker || !doc?.ad) return <TemplatePicker />;
  return (
    <div className={s.studio} data-testid="ad-studio">
      <div className={s.bar}>
        <button data-testid="ad-templates" onClick={() => useAdUi.setState({ picker: true })}>
          ← {t('adTemplates')}
        </button>
        <button data-testid="open-brand" onClick={() => useAdUi.setState({ brandOpen: true })}>
          🎨 {t('adMyBrand')}
        </button>
        <button data-testid="ad-undo" disabled={!canUndo} onClick={() => useDesign.getState().undo()}>
          ↶ {t('undoBig')}
        </button>
        <button disabled={!canRedo} onClick={() => useDesign.getState().redo()}>
          ↷ {t('redo')}
        </button>
        <span style={{ flex: 1 }} />
        {busy === 'photo' && <span role="status">{t('adPreparingPhoto')}</span>}
        <strong style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {doc.name}
        </strong>
      </div>
      <DesignCanvas />
      <aside className={s.form}>
        <AdForm />
      </aside>
    </div>
  );
}
